import { createFileRoute } from "@tanstack/react-router"

import { PacketPresetsTab } from "../../../../components/deal-packets/presets/preset-list"

export const Route = createFileRoute("/$dealership/deal-packets/presets/")({
  component: PresetsPage,
})

function PresetsPage() {
  return <PacketPresetsTab />
}
